import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { QuickInvoiceDialog } from "../components/QuickInvoiceDialog";

export default function FacturaRapida() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  return (
    <QuickInvoiceDialog
      open={open}
      onOpenChange={(o) => { setOpen(o); if (!o) navigate("/facturas"); }}
      onSaved={() => navigate("/facturas")}
    />
  );
}
